import { Flex, Text } from '@similarweb/ui-components/foundations';
import { CampaignModal } from '../../common/modals/CampaignModal';

import {
    DiscountText,
    LimitedTimeOffer,
    PercentText,
    SEASONAL_CAMPAIGN_MODAL_STYLE,
    SEASONAL_CAMPAIGN_TIMER_THEME,
    SeasonalCampaignModalContent
} from './StyledSeasonalCampaignModal';
import { useSeasonalCampaignModal } from './useSeasonalCampaignModal';
import { CountdownTimer } from 'app/components/timers/CountdownTimer/CountdownTimer';
import { colorsPalettes } from '@similarweb/styles';
import { Button } from '@similarweb/ui-components';
import { I18n } from '@similarweb/i18n-provider';
import { useTranslation } from 'pro-features/components/WithTranslation/src/I18n';
import { SEASONAL_CAMPAIGN_MODAL_TRANSLATION_KEYS } from './translationKeys';
import { SEASONAL_CAMPAIGN_DISCOUNT_PERCENTAGE } from 'app/marketing/hooks/campaing-hooks/seasonal-campaign/useSeasonalCampaignTypes';

export const SeasonalCampaignModal = () => {
    const { isOpen, isUpgradedToAnnual, promoCode, discountEndDate, handleClose, onCtaClick } =
        useSeasonalCampaignModal();

    const subTextKey = isUpgradedToAnnual
        ? SEASONAL_CAMPAIGN_MODAL_TRANSLATION_KEYS.subTextToAnnual
        : SEASONAL_CAMPAIGN_MODAL_TRANSLATION_KEYS.subText;

    const translate = useTranslation();

    return (
        <CampaignModal
            dataAutomation="seasonal-campaign-modal"
            customStyles={SEASONAL_CAMPAIGN_MODAL_STYLE}
            isOpen={isOpen}
            onClose={handleClose}
        >
            <SeasonalCampaignModalContent>
                <Flex
                    flexDirection="column"
                    gap="27px"
                >
                    <Flex
                        flexDirection="column"
                        gap="18px"
                        alignItems="center"
                    >
                        <LimitedTimeOffer fontVariant="body2">
                            {translate(SEASONAL_CAMPAIGN_MODAL_TRANSLATION_KEYS.limitedTimeOffer)}
                        </LimitedTimeOffer>
                        <Text
                            fontVariant="h1"
                            color={colorsPalettes.blue[50]}
                        >
                            {translate(SEASONAL_CAMPAIGN_MODAL_TRANSLATION_KEYS.flashSale)}
                        </Text>
                        <Text fontVariant="body1">
                            <I18n
                                dangerouslySetInnerHTML={true}
                                i18nKey={subTextKey}
                            />
                        </Text>

                        <DiscountText fontVariant="h1">
                            {SEASONAL_CAMPAIGN_DISCOUNT_PERCENTAGE}
                            <PercentText fontVariant="h1">%</PercentText>
                        </DiscountText>
                    </Flex>

                    <Flex
                        flexDirection="column"
                        gap="9px"
                    >
                        <CountdownTimer
                            discountEndTime={discountEndDate}
                            theme={SEASONAL_CAMPAIGN_TIMER_THEME}
                        />
                        <Text
                            fontVariant="body2"
                            color={colorsPalettes.midnight[50]}
                        >
                            {translate(SEASONAL_CAMPAIGN_MODAL_TRANSLATION_KEYS.promoCode)}:{' '}
                            <Text
                                fontVariant="body2"
                                color={colorsPalettes.orange[300]}
                            >
                                {promoCode}
                            </Text>
                        </Text>
                    </Flex>
                </Flex>

                <Button
                    type="inverted"
                    onClick={onCtaClick}
                    color={colorsPalettes.midnight[600]}
                >
                    {translate(SEASONAL_CAMPAIGN_MODAL_TRANSLATION_KEYS.upgradeNow)}
                </Button>
            </SeasonalCampaignModalContent>
        </CampaignModal>
    );
};
